// removed by extract-text-webpack-plugin
module.exports = {"Backdrop":"BackDrop_Backdrop_1p8pW"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ui/BackDrop/BackDrop.css
// module id = 133
// module chunks = 3